import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.4.3_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@playwright+test@1.62.1_@types+_ccd77f23b0d310a71d33aeedbbbbaa1e/node_modules/next/dist/client/app-dir/link.js");
